/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Api_Errors_Tenant_Write_Requires_MembershipInputs */

const nl_auth_api_errors_tenant_write_requires_membership = /** @type {(inputs: Auth_Api_Errors_Tenant_Write_Requires_MembershipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deze actie vereist dat je docent bent op deze school.`)
};

/**

* @param {Auth_Api_Errors_Tenant_Write_Requires_MembershipInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const auth_api_errors_tenant_write_requires_membership = /** @type {((inputs?: Auth_Api_Errors_Tenant_Write_Requires_MembershipInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Api_Errors_Tenant_Write_Requires_MembershipInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_auth_api_errors_tenant_write_requires_membership(inputs)
});
export { auth_api_errors_tenant_write_requires_membership as "auth.api_errors.tenant_write_requires_membership" }